import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export type ModalType =
	| 'campaign'
	| 'redirectApp'
	| 'firstAccess'
	| 'profileReady'

export const orderModalPriority: ModalType[] = [
	'campaign',
	'redirectApp',
	'firstAccess',
	'profileReady',
]

type State = {
	currentModal: ModalType | null
	dismissedModals: ModalType[]
	intents: Partial<Record<ModalType, boolean>>
}

const initialState: State = {
	currentModal: null,
	dismissedModals: [],
	intents: {},
}

const pickNextModal = (state: State) => {
	return (
		orderModalPriority.find(
			(modal) => state.intents[modal] && !state.dismissedModals.includes(modal)
		) ?? null
	)
}

export const modalPrioritySlice = createSlice({
	name: 'modalPriority',
	initialState,
	reducers: {
		requestOpen: (
			state,
			{ payload }: PayloadAction<{ type: ModalType; want: boolean }>
		) => {
			state.intents[payload.type] = payload.want

			state.currentModal = pickNextModal(state)
		},

		dismissModal: (state, { payload }: PayloadAction<ModalType>) => {
			if (!state.dismissedModals.includes(payload)) {
				state.dismissedModals.push(payload)
			}

			if (state.currentModal === payload) {
				state.currentModal = null
			}
			state.currentModal = pickNextModal(state)
		},
	},
})

export const modalPriorityCreators = modalPrioritySlice.actions
export const modalPriorityReducer = modalPrioritySlice.reducer
